// extracted by css-extract-rspack-plugin
export default {"container":"EROwJ8TwxnsRMaUV","head":"l_lltqJTYs0lO86v","back":"TXKwGFmKLfARgS7R","video":"HfGAYVPplGQtFsVW","results":"NWwLH2pEEkohssbQ"};